export default "__VITE_ASSET__z8fbJFWa__"